module.exports = __webpack_public_path__ + "img/drop-down-gray.c9da7c5c.svg";